module.exports = __webpack_public_path__ + "media/images/hamburger-16c349a10c58f2633950852b5a68be19.png";